import {
  alpha,
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export const selectMui: {
  defaultProps?: ComponentsProps['MuiSelect'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'];
  variants?: ComponentsVariants<Theme>['MuiSelect'];
} = {
  defaultProps: {
    size: 'medium',
    inputProps: { shrink: 'true' },
    variant: 'outlined',
  },
  variants: [
    {
      props: { variant: 'outlined', disabled: true },
      style() {
        return {
          '.MuiInputBase-input': {
            zIndex: 1,
          },
          '.MuiOutlinedInput-notchedOutline': {
            background: alpha('#ffffff', 0.05),
            borderColor: 'transparent !important',
            opacity: 0.7,
          },
          '.Mui-disabled': {
            cursor: 'not-allowed !important',
          },
        };
      },
    },
    {
      props: { variant: 'outlined' },
      style({ theme }) {
        return {
          minHeight: 28,
          fontSize: 12,
          // 28px de haut se pointent à la souris et se ratent au pouce ; 11px
          // de texte se lisent assis et moins bien debout. Sous md, le même
          // plancher que les boutons.
          [theme.breakpoints.down('md')]: {
            minHeight: 40,
            fontSize: 13,
          },
          fontWeight: 500,
          borderRadius: 4,
          background: '#050507',
          boxShadow: 'none',
          color: '#fafafa',
          '.MuiInputBase-input': {
            zIndex: 1,
            padding: '5px 10px',
            color: '#fafafa',
          },
          '.MuiOutlinedInput-notchedOutline': {
            background: 'transparent',
            borderColor: 'rgba(255,255,255,0.06)',
            borderRadius: 4,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.10)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(41,61,237,0.6)',
            borderWidth: 1,
          },
          '.MuiSelect-icon': {
            zIndex: 1,
            color: '#a3a3a3',
          },
          '.MuiInputBase-input::placeholder': {
            color: '#404040',
            opacity: 1,
          },
          // En dernier, pour l'emporter sur les règles ci-dessus : à
          // spécificité égale, c'est l'ordre d'émission qui tranche.
          // Même raison que pour les champs texte : sous 16px, iOS agrandit la
          // page à l'ouverture du sélecteur et n'y revient jamais.
          [theme.breakpoints.down('md')]: {
            minHeight: 40,
            fontSize: 16,
            '.MuiInputBase-input': {
              padding: '8px 12px',
            },
          },
        };
      },
    },
  ],
  styleOverrides: {
    root({ theme }) {
      return {
        '.MuiOutlinedInput-notchedOutline': {
          transition: `${theme.transitions.duration.shortest}ms`,
        },
      };
    },
  },
};
